const UA = function () {
    let UA = navigator.userAgent.toLowerCase(),
        isAndroid = /android|adr|linux/gi.test(UA),
        isIOS = /iphone|ipod|ipad/gi.test(UA) && !isAndroid,
        isBlackBerry = /blackberry/i.test(UA),
        isWindowPhone = /iemobile/i.test(UA),
        isOldNvwa = /lvjing/i.test(UA),
        isNvwa = /nvwa/i.test(UA),
        isWechat = /micromessenger/.test(UA),
        isUniApp = /uni-app/.test(UA),
        isPc = function () {
            var userAgentInfo = navigator.userAgent;
            var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod","HarmonyOS","Phone");
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        },
        isWeChatApplet = function () {
            // 是否为微信小程序
            const ua = window.navigator.userAgent.toLowerCase();
            if (ua.indexOf('micromessenger') == -1) {//不在微信或者小程序中
                return false
            }
            return ua.indexOf('miniprogram') > -1;
        }

    return {
        isAndroid: isAndroid,
        isIOS: isIOS,
        isBlackBerry: isBlackBerry,
        isWindowPhone: isWindowPhone,
        isNvwa: isNvwa,
        isOldNvwa: isOldNvwa,
        isWeChat: isWechat,
        isPc: isPc(),
        isUniApp:isUniApp,
        isWeChatApplet: isWeChatApplet()
    }
}

export default {
    UA: UA()
}
